
import { Component, Vue } from 'nuxt-property-decorator'
import meta from '@/helpers/meta'

@Component
export default class AboutPage extends Vue {
  public head() {
    return meta(
      'Chi siamo',
      'Associazione astagiudiziaria.com',
      this.$config.siteUrl + 'img/logo.png',
      this.$config.siteUrl + 'chi-siamo'
    )
  }

  mounted() {
    // aggiungo l'evento scroll per il parallax
    document.addEventListener('scroll', this.handleScroll)
  }

  beforeDestroy() {
    // rimuovo l'evento scroll per il parallax
    document.removeEventListener('scroll', this.handleScroll)
  }

  // funzione per il parallax
  public handleScroll() {
    const parallaxes = document.getElementsByClassName('parallax')
    if (parallaxes[0]) {
      const element = parallaxes[0] as HTMLDivElement
      element.style.backgroundPositionY = -100 + window.scrollY * -1 + 'px'
    }
    if (parallaxes[1]) {
      const element = parallaxes[1] as HTMLDivElement
      element.style.backgroundPositionY = window.scrollY * -0.5 + 'px'
    }
  }
}
